import {
  ComputedFieldPropertyType,
  ComputedSchemaFieldDependencyResponse,
} from 'schemas/fields/SchemaFieldConstants';

export const LITERAL_COMPUTED_FIELD_DEPENDENCY: ComputedSchemaFieldDependencyResponse = {
  name: 'val1',
  assaySchemaName: null,
  fieldPath: null,
  literalValue: 'LITERALLY',
  property: ComputedFieldPropertyType.LITERAL,
};
